<div class="sidebar-area bg-white box-shadow" [ngClass]="{'active': isToggled}"
    [class.dark-sidebar]="themeService.isSidebarDark()" [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()">
    <div class="logo bg-white">
        <a class="d-flex align-items-center">
            <!-- <img src="img/logo-icon.png" alt="logo"> -->

            @if(themeService.isDark()){
            <img src="img/white-solitx-logo.png" alt="logo">

            }@else{
            <img src="img/black-solitx-icon.png" alt="logo">
            }

        </a>
    </div>
    <div class="burger-menu" (click)="toggle()" [ngClass]="{'active': isToggled}">
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>
    <ng-scrollbar visibility="hover" style="height: 100vh;">
        <div style="display: grid;grid-template-rows: 1fr 0fr;height: 100vh;">

            <div class="sidebar-inner">
                <div class="sidebar-menu">
                    <mat-accordion>
                        <a routerLink="/dashboard" class="sidebar-menu-link" routerLinkActive="active">
                            <span class="material-symbols-outlined">
                                dashboard
                            </span>
                            <span class="title">Dashboard</span>
                        </a>

                    </mat-accordion>
                </div>
                <div class="sidebar-menu">
                    <mat-accordion>
                        <a routerLink="/profiles" class="sidebar-menu-link" routerLinkActive="active">

                            <span class="material-symbols-outlined">
                                person_2
                            </span>


                            <span class="title">Profiles</span>
                        </a>

                    </mat-accordion>
                </div>
                <div class="sidebar-menu">
                    <mat-accordion>
                        <a routerLink="/contracts" class="sidebar-menu-link" routerLinkActive="active">

                            <!-- <mat-icon fontIcon="contract"></mat-icon> -->
                            <span class="material-symbols-outlined">
                                contract
                            </span>
                            <span class="title">Contracts</span>
                        </a>

                    </mat-accordion>
                </div>
                <div class="sidebar-menu">
                    <mat-accordion>
                        <a routerLink="/events" class="sidebar-menu-link" routerLinkActive="active">
                            <!-- <span class="material-symbols-outlined">
                                notifications
                            </span> -->
                            <span class="material-symbols-outlined"> overview </span>
                            <span class="title">Events</span>
                        </a>

                    </mat-accordion>
                </div>
                <div class="sidebar-menu">
                    <mat-accordion>
                        <a routerLink="/transactions" class="sidebar-menu-link" routerLinkActive="active">
                            <span class="material-symbols-outlined">
                                sync_alt
                            </span>
                            <span class="title">Transactions</span>
                        </a>

                    </mat-accordion>
                </div>

                <div class="sidebar-menu">
                    <mat-accordion>
                        <a routerLink="/ledgers" class="sidebar-menu-link" routerLinkActive="active">
                            <span class="material-symbols-outlined">
                                data_table
                            </span>
                            <span class="title">Ledgers</span>
                        </a>

                    </mat-accordion>
                </div>


            </div>
            <div class="pe-15 ps-15 mb-20">
                <div class="sidebar-menu">
                    <mat-accordion>

                        <!-- logout -->
                        <a (click)="logout()" class="sidebar-menu-link" routerLinkActive="active"
                            style="cursor: pointer;" [routerLinkActiveOptions]="{exact: true}">
                            <!-- <i class="ri-shut-down-line"></i> -->
                            <span class="material-symbols-outlined">
                                logout
                            </span>
                            <app-loading class="d-flex justify-content-start align-items-center"
                                [loading]="appStore.loading()" [text]="'Logging out...'"
                                [size]="14">Logout</app-loading>

                            <!-- <span class="title">Logout</span> -->
                        </a>
                    </mat-accordion>
                </div>

                <!-- <div class="sidebar-menu mt-30 mb-10">
                    <mat-accordion>
                        <a (click)="logout()" class="sidebar-menu-link location-footer pe-5">
                            <mat-icon class="material-symbols-outlined" fontIcon="location_on"></mat-icon>
                            <app-loading [loading]="locationStore.isLoading()" [size]="19">
                                <span
                                    class="d-block fw-semibold gray-color">{{locationStore.locationInfo()?.country}}</span>
                                <span class="d-block location-ip fs-13">From your ip address</span>
                            </app-loading>
                        </a>
                    </mat-accordion>
                </div> -->
                <!-- <mat-accordion>
                    <div class="location-footer-container mt-30 mb-10">
                        <div class="location-footer d-flex align-items-center">
                            <mat-icon class="material-symbols-outlined" fontIcon="location_on"></mat-icon>
                            <div class="location-footer-textual ms-5">
                                <app-loading [loading]="locationStore.isLoading()" [size]="19">
                                    <span
                                        class="d-block fw-semibold gray-color">{{locationStore.locationInfo()?.country}}</span>
                                    <span class="d-block location-ip fs-13">From your ip address</span>
                                </app-loading>

                            </div>
                        </div>
                    </div>
                </mat-accordion> -->
            </div>
        </div>
    </ng-scrollbar>
</div>